import * as Sentry from '@sentry/react';
import { z } from 'zod';

export function skipInvalidItems<TItem extends z.ZodTypeAny>(itemSchema: TItem, label: string) {
    return z.array(z.unknown()).transform((items) =>
        items.flatMap((item): Array<z.infer<TItem>> => {
            const result = itemSchema.safeParse(item);
            if (result.success) return [result.data];

            const id = typeof item === 'object' && item !== null && 'id' in item ? item.id : undefined;
            const issuePaths = result.error.issues.map((issue) => issue.path.join('.'));
            const extra = { id, issuePaths, label };
            Sentry.captureMessage(`${label}: skipped invalid item`, { extra, level: 'error' });
            return [];
        }),
    );
}
